import React, { useEffect, useReducer,useState } from 'react';
import { useForm } from 'react-hook-form';
// import { useHistory } from 'react-router';
import { competitionService } from './competitionService';
// import { DisciplineSelector } from '../discipline';
// import { ShowSelector } from '../show';
import { useNavigate } from 'react-router-dom';
// import { HorseSelector } from '../horse';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';

import { disciplineService } from "../discipline/disciplineService";


const initialState = {
    isLoading: false,
    isSubmitting: false,
    serverCommunication: undefined,
    competitionId: undefined
}

const ACTIONS = {
    COMPETITION_CREATE_CALL: 'COMPETITION_CREATE_CALL',
    COMPETITION_CREATE_SUCCESS: 'COMPETITION_CREATE_SUCCESS',
    COMPETITION_CREATE_ERROR: 'COMPETITION_CREATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.COMPETITION_CREATE_CALL:
            return {
                ...state,
                isLoading: true
            };
        case ACTIONS.COMPETITION_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                competitionId: action.data.id
            };
        case ACTIONS.COMPETITION_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                serverCommunication: action.data
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function CompetitionCreate({ show}) {

   // console.log(show);

    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [deciples , setDisciples] = useState(null);
    const {contextValue } = useAuth();


    useEffect(() => {
        handleSlectorInputChange('');
    },[]);
    // const history = useHistory();

    // useEffect(() => {
    //     if (state.competitionId) {
    //         history.push(`/competition/${state.competitionId}`);
    //     }
    // }, [state.competitionId, history]);


        const navigate = useNavigate();

        useEffect(() => {
            if (state.competitionId) {
                navigate(`/competition/${state.competitionId}`);
            }
        }, [state.competitionId, navigate]);


    function handleDisciplineCreate(competition) {
        // competition = {...competition, Horses: 
        //     {
        //         "horseId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        //         "backNumber": 0,
        //         "place": 0,
        //         "points": 0,
        //         "ribbon": "None"
        //     }
        // };


       // console.log(competition);
        dispatch({ type: ACTIONS.COMPETITION_CREATE_CALL });
        //console.log(competition);

        contextValue.showLoader();
        contextValue.updateLoaderText("Creating competition...");


        competitionService.createCompetition({
            ...competition,
            // DisciplineId: competition.discipline?.id,
            // ShowId: competition.show?.id
        })
        .then(response => 
            {
                toast.success("Competition created successfully");
                dispatch({ type: ACTIONS.COMPETITION_CREATE_SUCCESS, data: response.data })
            }
        
        )
        .catch(error =>{
            toast.error("Error creating competition");
            dispatch({ type: ACTIONS.COMPETITION_CREATE_ERROR, data: error.response.data })
        })

        .finally(() => contextValue.hideLoader());

    }


    function handleSlectorInputChange(value) {
            disciplineService.indexDisciplines({
                sortOrder: null,
                searchString: value,
                pageSize: 100,
                pageNumber: 1
            })
            .then(response =>{
                setDisciples(response.data.entities)
            }
                
            )
            .catch(error => console.error(error));
    }
    

    return (
        <form onSubmit={handleSubmit(handleDisciplineCreate)}>
        <div className='mb-3'>
            <label htmlFor='newCompetitionName' className='form-label'>Name</label>
            <input type='text' className='form-control' id='newCompetitionName' autoComplete='off' {...register('name', { required: "Name is required" })}/>
            {/* {errors.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>} */}
            {errors.name && <p className='text-danger form-text'>{errors.name.message}</p>}
        </div>
        <div className='mb-3'>
            <label htmlFor='newCompetitionClassNumber' className='form-label'>Class Number</label>
            <input type='text' className='form-control' id='newCompetitionClassNumber' autoComplete='off' {...register('classNumber')}/>
        </div>
        <div className='mb-3'>
            <label htmlFor='newCompetitionDiscipline' className='form-label'>Discipline</label>

            <select name="DisciplineId" id="" className='form-select' {...register('DisciplineId',{
                required: "Discipline is required"
            })}>
                <option value="">Select Discipline</option>
                {deciples?.map((discipline) => (
                    <option key={discipline.id} value={discipline.id}>{discipline.discipline_name}</option>
                ))}
            </select>

            {errors.DisciplineId && <p className='text-danger form-text'>{errors.DisciplineId.message}</p>}

            {/* <DisciplineSelector className='form-control' id='newCompetitionDiscipline' onChange={(value) => setValue('discipline', value)}/> */}
        </div>
        <div className='mb-3'>
            {/* <label htmlFor='newCompetitionShow' className='form-label'>Show</label> */}

            <input type='hidden' className='form-control' id='newCompetitionClassNumber' 
            value={show?.id || ''}
            autoComplete='off' {...register('ShowId')}/>

            {/* <ShowSelector className='form-control' id='newCompetitionShow' onChange={(value) => setValue('show', value)}/> */}
        </div>

       {/* <div className='mb-3'>
                <label htmlFor='newHorseSire' className='form-label'>Horse</label>
                <HorseSelector className='form-control' id='newHorseSire' onChange={(value) => {
                    console.log(value);
                    setValue('Horses', value)}}></HorseSelector>
                <div className='form-text'>If the sire does not exist in our database, you will have to create it separately.</div>
        </div>  */}


        <div className='mb-3'>
            <label htmlFor='newCompetitionStartDateTime' className='form-label'>Start Date and Time</label>
            <input type='datetime-local' className='form-control'
            
            id='newCompetitionStartDateTime' autoComplete='off' {...register('startDateTime',{
                required: "Start Date and Time is required"
            })}/>

            {errors.startDateTime && <p className='text-danger form-text'>{errors.startDateTime.message}</p>}

        </div>
        <div className='mb-3'>
            <label htmlFor='newCompetitionOrder' className='form-label'>Order</label>
            <input type='text' className='form-control' id='newCompetitionOrder' autoComplete='off' {...register('order')}/>
        </div>
        <div className='mb-3'>
            <label htmlFor='newCompetitionPdfUrl' className='form-label'>PDF URL</label>
            <input type='text' className='form-control' id='newCompetitionPdfUrl' autoComplete='off' {...register('pdfUrl')}/>
        </div>
        {state.serverCommunication && <p className='text-danger'>{state.serverCommunication.messages}</p>}
        <button className='btn btn-success text-white w-100' type='submit'>Create</button>
    </form>
    );
}

export default CompetitionCreate;